import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateModules } from "../../actions";
import {
  OsnTextarea,
  Button,
  OsnInputText,
} from "@identitybuilding/idb-react-ui-elements";
import axios from "axios";
import SocialNews from "@identitybuilding/idb-react-social-news/dist/SocialNews";

const SocialNewsEdit = (props) => {
  const dispatch = useDispatch();

  let modules = useSelector((state) => state.AdminReducer.modules);
  let data = useSelector((state) => state.AdminReducer.data);

  let [socialNewsTitle, setSocialNewsTitle] = useState(
    data.options.social_news.title
  );
  let entityCopy = Object.assign({}, data);
  let modulcesCopy = [...modules];

  const handler = (action, keyword) => {
    if (action === "template") {
      entityCopy.options.social_news.template = keyword;
      adminChange(keyword, action);
    }
    if (action === "title") {
      entityCopy.options.social_news.title = keyword;
      adminChange(keyword, action);
    }
    if (action === "theme") {
      entityCopy.options.social_news.theme = keyword;
      adminChange(keyword, action);
    }

    modulcesCopy[props.index].module = (
      <SocialNews
        template={entityCopy.options.social_news.template}
        theme={entityCopy.options.social_news.theme}
        posts={entityCopy.options.social_news.posts}
        title={entityCopy.options.social_news.title}
      />
    );
    dispatch(updateModules(modulcesCopy));
    // setModules(modulcesCopy);
  };
  const adminChange = (props, action) => {
    axios
      .put(
        `https://onepage-78a00-default-rtdb.europe-west1.firebasedatabase.app/data/data/options/social_news.json`,
        {
          [action]: props,
          ...entityCopy.options.social_news,
        }
      )
      .then(async (resp) => {
      });
  };

  return (
    <div className="testBlock">
      <div className="testTitle">Social</div>
      <div>
        <span>Title:</span>
        <OsnInputText
          onChange={(e) => setSocialNewsTitle(e.target.value)}
          value={socialNewsTitle}
          placeholder={socialNewsTitle}
        />
        <Button
          bgColor={["cn"]}
          size="S"
          text="Change title"
          txtColor="white"
          type="main"
          onClick={() => handler("title", socialNewsTitle)}
        />
      </div>
      <div>
        <span>Template:</span>
        <ul>
          <li onClick={() => handler("template", 1)}>1</li>
          <li onClick={() => handler("template", 2)}>2</li>
        </ul>
      </div>
      <div>
        <span>Theme:</span>
        <ul>
          <li onClick={() => handler("theme", "dark")}>dark</li>
          <li onClick={() => handler("theme", "light")}>light</li>
        </ul>
      </div>
    </div>
  );
};

export default SocialNewsEdit;
